import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/apiClient";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [msg, setMsg] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setBusy(true);
        try {
            await api.post("/auth/reset-password", { token, new_password: password });
            setMsg("Password reset successful. Redirecting to sign in...");
            setTimeout(() => navigate("/login"), 1500);
        } catch (e) {
            setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-6" data-testid="reset-page">
            <form onSubmit={submit} className="w-full max-w-sm" data-testid="reset-form">
                <div className="font-serif text-2xl mb-1">Set a new password</div>
                <p className="text-sm text-zinc-500 mb-8">Pick something you'll remember.</p>
                <label className="caption">New password (min 6 chars)</label>
                <input
                    type="password"
                    required
                    minLength={6}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    data-testid="reset-password"
                    className="mt-2 mb-5 w-full bg-[#18181B] border border-white/10 rounded-md px-3 py-2.5 text-sm focus:border-[#D4AF37]/60"
                />
                {msg && (
                    <div className="mb-4 px-3 py-2 bg-[#5B8A62]/10 border border-[#5B8A62]/30 rounded-md text-sm text-[#B9DBB9]" data-testid="reset-success">
                        {msg}
                    </div>
                )}
                {err && (
                    <div className="mb-4 px-3 py-2 bg-[#B95050]/10 border border-[#B95050]/30 rounded-md text-sm text-[#E8A5A5]" data-testid="reset-error">
                        {err}
                    </div>
                )}
                <button
                    type="submit"
                    disabled={busy || !token}
                    data-testid="reset-submit"
                    className="w-full bg-[#D4AF37] text-[#0E0E10] font-medium px-4 py-2.5 rounded-md hover:bg-[#B3922E] disabled:opacity-50"
                >
                    {busy ? "Saving..." : "Reset password"}
                </button>
                <div className="mt-6 text-center text-sm text-zinc-500">
                    <Link to="/login" className="text-[#D4AF37] hover:underline" data-testid="reset-back-link">
                        Back to sign in
                    </Link>
                </div>
            </form>
        </div>
    );
}
